import { app } from "@/config/env";
import { RudderAnalytics } from "@rudderstack/analytics-js";

const WRITE_KEY = app.RUDDERSTACK.WRITE_KEY;
const DATA_PLANE_URL = app.RUDDERSTACK.DATA_PLANE_URL;

const rudderanalytics = new RudderAnalytics();

const initRudder = () => {
  rudderanalytics.load(WRITE_KEY, DATA_PLANE_URL, {
    bufferDataPlaneEventsUntilReady: true,
    autoTrack: { enabled: false },
    useBeacon: true,
    logLevel: app.ENV !== "local" ? "DEBUG" : "ERROR",
  });
};

export { rudderanalytics, initRudder };
